import { Disclosure, Transition } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';

export default function NotFoundOrganizations() {
  return (
    <div className="w-full">
      <div className="ml-0 w-full max-w-lg rounded-lg bg-slate-300 p-2 text-left dark:bg-slate-600">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg bg-slate-100 px-4 py-2 text-left font-medium hover:bg-slate-200 focus:outline-none focus-visible:ring dark:bg-slate-500">
                <span>Не нашли ветеринарную клинику в вашем городе?</span>
                <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-6 w-6 text-black dark:text-white`}
                />
              </Disclosure.Button>
              <Transition
                show={open}
                enter="transition duration-300 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
              >
                <Disclosure.Panel className="px-4 pt-4 pb-2">
                  <p className="mb-2">На странице выбранного города вы сможете:</p>
                  <ul className="ml-4 list-disc">
                    <li>Найти ближайшие к вам ветеринарные клиники.</li>
                    <li>Прочитать отзывы других пользователей. (Скоро будет)</li>
                  </ul>
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  );
}
